import { AxiosResponse } from 'axios';
import api from '../../../services/api';

class LoadControl {
  getAll(status) {
    return api.get(`/load/?status=${status}`);
  }

  getLoadControl(id) {
    return api.get(`/load/${id}`);
  }

  deleteLoadControl(id: any) {
    return api.delete(`/load/${id}`);
  }
  createLoadControl(payload: any): Promise<AxiosResponse<any | null>> {
    return api.post('/load/', payload);
  }
  editLoadControl(payload: any): Promise<AxiosResponse<any | null>> {
    return api.put('/load/', payload);
  }

  cancelLoadControl(payload: any): Promise<AxiosResponse<any | null>> {
    return api.put('/load/cancel', payload);
  }
}

export default new LoadControl();
